export default __webpack_public_path__ + "img/screenshot_4.a59a8f29.png";